export default __webpack_public_path__ + "static/media/felt-logo-glowing.0acdbc70.png";